let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

export function playBellNotification() {
  const audio = new Audio('/bell-notification.wav');
  audio.volume = 0.3;
  audio.play().catch(() => {
    /* user gesture not yet available, ignore */
  });
}

export function playBellChime() {
  const audio = new Audio('/bell-chime.wav');
  audio.volume = 0.15;
  audio.play().catch(() => {
    /* user gesture not yet available, ignore */
  });
}

export function playSoftBeep() {
  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    gain.gain.setValueAtTime(0.08, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.15);
  } catch {
    /* audio not available, ignore */
  }
}
